import axios from "axios";
import AccountDetectionModeResult from "../models/responses/AccountDetectionModeResult";

const instance = axios.create({
  baseURL: "/AutoConnectSSO/api/InscriptionFlow/AccountDetectionMode",
  withCredentials: true
});

async function List() {
  return instance.get<AccountDetectionModeResult[]>(`/List`);
}

export const AccountDetectionModeService = {
  List
};
